import type { Step } from "../script";

export const crossMerchantPattern: Step[] = [
  {
    kind: "msg",
    id: "msg-05a",
    tokens:
      "one cross-merchant pattern. purederm's refund rate dropped from 0.5% to 0.14% over 3 weeks. on a high-cb subscription merchant, that usually means the cancel path broke.",
    pauseAfter: 1200,
  },
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "intel-graph" },
    pauseAfter: 1300,
  },
  {
    kind: "msg",
    id: "msg-05b",
    tokens:
      "3 others on the same cluster. dispatching a prevention briefing to all 4 — ~10–14% dispute reduction if they act within 14 days. override to skip.",
    pauseAfter: 900,
  },
  {
    kind: "act",
    id: "act-briefing",
    title: "dispute-prevention briefing · 4 merchants",
    body: "purederm · vitalblend · matchmoment · corewellness",
    receipt: "CLUSTER BRIEFING · 4 merchants · dispatched",
    actMs: 5400,
  },
];
